import { useFetchTeamsQuery } from '../../store/team/TeamApi';
import { useParams } from 'react-router';
import { CircularProgress, Grid } from "@mui/material";
import TeamDetail from "../team/TeamDetail"; 


export default function TeamDetails({selectedYear, selectedClub})
{

  const params = useParams();
  const clubLabelParameter = params.clubLabel;
  const yearParameter = params.year;

  const {data:teams, isLoading:teamsAreLoading} = useFetchTeamsQuery({
    year: yearParameter, 
    clubLabel: clubLabelParameter,
  });


  // Ausgeben der Seite mit den Teaminformationen
  if (!yearParameter||!clubLabelParameter||teamsAreLoading||!teams)
  {
    // Wir zeigen in der Mitte der Liste einfach ein Zeichen, dass
    // wir noch am Laden sind: 
    return(
      <CircularProgress />
    );
  }
  
  return (
    <>
      {
        [...teams]
        .sort((a,b) => {
          if (a.is_female !== b.is_female ) return a.is_female ? -1 : 1;
          if (a.is_u8 !== b.is_u8 ) return a.is_u8 ? -1 : 1;
          return a.counter - b.counter;
        })
        .map(
          team =>  
          (
            <Grid key={team.id} size={12}>
              <TeamDetail 
                year={selectedYear} 
                club={selectedClub} 
                team={team} 
              />
            </Grid>
          )
        )
      }
    </>      
  );
}